import { AsyncPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { LIB_CONFIG, LibConfig } from '../../../lib.config';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';
import { UrlService } from '../../../services/state/url.service';

@Component({
  selector: 'now-wbsuche-lib-required-inputs-state',
  templateUrl: './required-inputs-state.component.html',
  styleUrls: ['./required-inputs-state.component.scss'],
  imports: [NgClass, NgOptimizedImage, AsyncPipe]
})
export class RequiredInputsStateComponent {
  private readonly urlService = inject(UrlService);
  libConfig = inject<LibConfig>(LIB_CONFIG);
  private readonly screenSizeService = inject(ScreenSizeService);

  mobileView$ = this.screenSizeService.rangeTo$(ViewMode.PHABLET);

  async navigateToThemenfelder() {
    await this.urlService.updateUrl(null, 'themenfelder');
  }
}
